import state from './state';
import * as getters from './getters';
import mutations from './mutations';
import * as actions from './actions';

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
